import { createStore } from 'vuex'

import dropdown from '../../shared/vue/store/modules/dropdown'

let store = null

export function clearStore() {
  store = null
}

window.addEventListener('turbolinks:before-visit', clearStore)

export default function createInsightsStore() {
  if (store) {
    return store
  }

  store = createStore({
    modules: {
      dropdown,
    },
  })

  return store
}
